import { Space, Typography } from 'antd';
import ConfirmationModal from 'components/new-ui/composed/modal/confirmation-modal/ConfirmationModal';
import { MessageTypes } from 'store/declarations/enums/common/declaration-types';

type Props = {
    open: boolean;
    messageType: MessageTypes;
    onValidate: () => void;
    onSkipValidation: () => void;
    onClose: () => void;
};

// Raised when the declaration has master level errors. Neither answer is a dead end: validating
// keeps the user on the form with the offending fields highlighted, skipping opens the preparation
// page and leaves those errors for the generated declaration.
const ValidateBeforeGeneratingModal = ({ open, messageType, onValidate, onSkipValidation, onClose }: Props) => (
    <ConfirmationModal
        open={open}
        title={`Validate Before Generating ${messageType}?`}
        confirmButtonText="Validate"
        cancelButtonText="Skip Validation"
        onConfirm={onValidate}
        onCancel={onSkipValidation}
        onClose={onClose}
        content={
            <Space size={12} direction="vertical" style={{ paddingInline: 16, paddingBottom: 16, width: '100%' }}>
                <Typography.Text>
                    Validating checks the master level details of this declaration. Anything missing or invalid is
                    highlighted in the form for you to fix, and the {messageType} preparation opens once it all passes.
                </Typography.Text>
                <Typography.Text>
                    Proceeding without validating opens the {messageType} preparation straight away, leaving any master
                    level issues to be resolved later. Item level issues are reviewed there either way.
                </Typography.Text>
            </Space>
        }
    />
);

export default ValidateBeforeGeneratingModal;
